/**
 * A picked file's bytes as base64, with no `data:...;base64,` prefix: the wire
 * shape of every JSON-body file upload (PO files, invoices, the just-in-time
 * receipt). Rejects with "Failed to read file" when the browser cannot read it.
 *
 * Product Dev keeps its own reader (`features/product-dev/utils/file-upload.ts`),
 * which returns more than the bytes.
 */
export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Unexpected file read result'));
        return;
      }
      const base64 = result.split(',')[1];
      if (!base64) {
        reject(new Error('Failed to read file'));
        return;
      }
      resolve(base64);
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}
